import { useSyncExternalStore } from 'react';

export type NotifSeverity = 'info' | 'warn' | 'error' | 'success';

export interface Notification {
  id: string;
  severity: NotifSeverity;
  title: string;
  body?: string;
  ts: number;
  read: boolean;
  href?: string;
}

type Listener = () => void;

let state: Notification[] = [];
const listeners = new Set<Listener>();

function notify() {
  listeners.forEach((l) => l());
}

export const notifStore = {
  subscribe(l: Listener) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
  getSnapshot() {
    return state;
  },
  push(n: Omit<Notification, 'id' | 'ts' | 'read'>) {
    state = [{ ...n, id: crypto.randomUUID(), ts: Date.now(), read: false }, ...state].slice(0, 100);
    notify();
  },
  markRead(id: string) {
    state = state.map((n) => (n.id === id ? { ...n, read: true } : n));
    notify();
  },
  markAllRead() {
    state = state.map((n) => ({ ...n, read: true }));
    notify();
  },
  dismiss(id: string) {
    state = state.filter((n) => n.id !== id);
    notify();
  },
  clear() {
    state = [];
    notify();
  },
};

export function useNotifications() {
  return useSyncExternalStore(notifStore.subscribe, notifStore.getSnapshot);
}
